export const ACTION_SEARCH_FILES = "ACTION_SEARCH_FILES";
export const ACTION_SET_SEARCH_FILES_RESULT = "ACTION_SET_SEARCH_FILES_RESULT";
